export var FormTypes;
(function (FormTypes) {
    // PRESETS
    let Preset;
    (function (Preset) {
        Preset["OUTPUT"] = "output";
        Preset["PREP_VALUE"] = "prepValue";
    })(Preset = FormTypes.Preset || (FormTypes.Preset = {}));
})(FormTypes || (FormTypes = {}));
